const pathAPI = '/user-service/api/otp';

export const apiOTP = {
    getOTP: `${pathAPI}/get`,
    confirmOTP: `${pathAPI}/verify`,
};
